import React from "react";
// @ts-ignore
import templatesGuide from "../../../assets/videos/template-guide.mp4";

export const TemplatesSection = ({ id }: { id: string }) => {
    return (
        <>
            <div className="description">
                We use templates to pre-define you messages, approve them with the service provider (Whatsapp or any other service provider) and automatically send them (after replacing placeholder helpers with real values) to your clients, at the moment you pre-define in the template.
            </div>
            <div className="video-section">
                <video controls src={templatesGuide} />
            </div>
            <div className="sub-section">
                <ol>
                    <li>
                        <div>
                            <div>To get started, navigate to your templates page, there you'll see a list of your existing templates, or an empty list if you haven't created any templates yet.</div>
                            <div>You'll also see an "Add Template" button at the top, click on it to create a new template</div>
                        </div>
                    </li>
                    <li>
                        <div>
                            <div>Type a title to your message, that details is only seen by you, and will help you identify the template in your templates list</div>
                            <div>Move on to writing text message (your template's body). This will be the body of the message that will be sent to your clients, so spend some time to create a respectful, attractive message so it will recover as many checkouts as possible.</div>
                            <div>Once you focus on the text message content, you should also notice the Placeholders Helpers. Those are placeholders that will be replace to your client's checkout real details once this template will be used to send a message.</div>
                            <div>While composing your template, you'll notice placeholder helpers that allow you to add dynamic content to your message. To include a coupon code in your template, click on a placeholder helper of type "coupon code" at the appropriate position within the template's body.</div>
                        </div>
                    </li>
                    <li>
                        <div>
                            <div>Once the template is ready to use, it will wait for the time you defined for it to be sent, check if the client's checkout contains any of the coupon-eligible products, and if so - it will send the template message.</div>
                            <div>If no coupon-eligible product found in the client's checkout, the template message will not be sent for that specific checkout.</div>
                        </div>
                    </li>
                </ol>
            </div>
            <div className="sub-section">
                <div>It's important to note that defining a list of allowed-products for auto-generated coupons is only effective if there is at least one template containing the "coupon code" placeholder. Without such a template, the auto-generated coupons cannot be utilized, and vice versa.</div>
            </div>
            <div className="sub-section">
                <div>By following these steps, you can seamlessly integrate coupon generation and distribution into your marketing efforts, enhancing customer engagement and driving sales. Should you need any assistance or further information, our support team is always available to help.</div>
            </div>
        </>
    );
}